import Rollbar from 'rollbar';

const accessToken = import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN?.trim();
const endpoint = import.meta.env.VITE_ROLLBAR_ENDPOINT?.trim();

if (import.meta.env.DEV && !accessToken) {
  console.warn('Rollbar disabled: missing VITE_ROLLBAR_ACCESS_TOKEN in frontend/.env');
}

export const rollbarConfig: Rollbar.Configuration = {
  accessToken,
  ...(endpoint ? { endpoint } : {}),
  environment: import.meta.env.MODE,
  enabled: Boolean(accessToken) && import.meta.env.PROD,
  captureUncaught: true,
  captureUnhandledRejections: true,
  captureIp: 'anonymize',
  scrubFields: ['password', 'secret', 'token', 'authorization', 'credit_card'],
  payload: {
    environment: import.meta.env.MODE,
    platform: 'browser',
    client: {
      javascript: {
        code_version: import.meta.env.VITE_APP_VERSION,
        source_map_enabled: true,
      },
    },
  },
};

const rollbar = new Rollbar(rollbarConfig);

export default rollbar;
